module.exports = __webpack_public_path__ + "img/0Q3C0560_Black.c9d17e90.jpg";